import { render, staticRenderFns } from "./TiersList.vue?vue&type=template&id=608ed8d4&"
import script from "./TiersList.vue?vue&type=script&lang=js&"
export * from "./TiersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports